import React from 'react';
import { useHistory } from 'react-router-dom';
import i18n from 'i18n';
import styled from 'styled-components/macro';
import { FocusableParent } from 'components/navigation';
import scaleSize from 'utils/scale-size';
import Button from 'components/Button';

export const WithoutContentWrapper = styled(FocusableParent)`
  width: ${scaleSize(700)}px;
  height: ${scaleSize(400)}px;
  text-align: center;
  position: absolute;
  top: ${scaleSize(330)}px;
  left: 50%;
  transform: translateX(-50%);
  > a {
    margin-right: 0;
  }
`;

export const WithoutContentText = styled.div`
  font-size: ${scaleSize(40)}px;
  margin-top: ${scaleSize(20)}px;
  margin-bottom: ${scaleSize(50)}px;
  line-height: 1.2;
  text-align: center;
  color: #9f9f9f;
`;

const EmptyDataStub = ({ emptyPlaceholder, icon, className, snLeft = '@TAB_PANEL' }) => {
  const history = useHistory();
  return (
    <WithoutContentWrapper className={className} defaultSection>
      {icon}
      <WithoutContentText>{emptyPlaceholder}</WithoutContentText>
      <Button snDown="" snLeft={snLeft} onEnter={() => history.push('/')}>
        {i18n.t('continueWatching.buttonStart')}
      </Button>
    </WithoutContentWrapper>
  );
};

export default EmptyDataStub;
